
































































import { eventBus } from "@/main";
import Vue from "vue";
import Component from "vue-class-component";
import {
  DisplayModule,
  RouterModule,
  SectionsModule,
  ArgumentsModule,
  UsersModule,
  VotingModule,
  CommentsModule
} from "@/store/store.helper";
import { CommentInterface, SectionInterface } from "@/types/interfaces";
import ownerData from "@/components/owner.data/owner.data.vue";
import * as enums from "@/types/enums";
import { Prop } from "vue-property-decorator";
import AddNew from "../../add.new/add.new";
import deletePopup from "../../delete.popup/delete.popup.vue";

@Component({
  components: {
    "owner-data": ownerData,
    "delete-popup": deletePopup,
    AddNew
  }
})
export default class cardComments extends Vue {
  @Prop() public argumentId: String;
  @Prop() public isDisabled: Boolean;
  @Prop() public section: SectionInterface;
  @Prop() public parentSectionId: String;
  @Prop() public pageStatus: Number;
  @Prop() public isUserEditor: Boolean;

  @SectionsModule.SectionsGetter private isDynamicFeed;
  @ArgumentsModule.ArgumentsGetter private argumentById;
  @SectionsModule.SectionsGetter private sectionById: (
    string
  ) => SectionInterface[];
  @DisplayModule.DisplayGetter private getBorderTopColor;
  @DisplayModule.DisplayGetter private showDeleteButton;
  @UsersModule.UsersGetter private isSignedIn;
  @UsersModule.UsersAction private signIn;
  @UsersModule.UsersGetter private userUid;
  @UsersModule.UsersAction private checkUserProperties;
  @RouterModule.RouterAction private pushWithParams;
  @CommentsModule.CommentsGetter private commentsByArgumentId: (
    string
  ) => CommentInterface[];

  private isDisplayed: boolean = false;
  private isShowNew: boolean = false;
  private comments: CommentInterface[] = [];
  private dialog = false;
  private itemDeleteId: string = "";
  private created() {
    eventBus.$on("toggleComments", argumentId => {
      if (this.argumentId === argumentId) {
        this.toggleComments();
      }
    });
    eventBus.$on("showNewComment", argumentId => {
      if (this.argumentId === argumentId) {
        this.isShowNew = true;
        eventBus.$emit('nextBtn', false);
      }
    });
    eventBus.$on("closeBox", () => {
      this.isShowNew = false;
    });
  }

  private beforeDestroy() {
    eventBus.$off('closeBox');
  }

  private toggleComments() {
    this.isDisplayed = true;
  }

  private showDialog(itemId) {
    this.dialog = true;
    this.itemDeleteId = itemId;
  }

  private async addComment() {
    if (!this.isSignedIn) {
      this.signIn();
    } else {
      eventBus.$emit("closeBox");
      this.isShowNew = true;
      eventBus.$emit('nextBtn', false);
    }
  }
}
